// extracted by mini-css-extract-plugin
module.exports = {"dashed":"list_dashed__3E3Fl"};